/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ACTIVE: 'active',
    HAS_CLIENTS_WITH_CREDITS: 'hasClientWithCredit',
    HAS_CLIENTS_WITH_PASS: 'hasClientWithPass',
    NOT_ACTIVE: 'notActive',
};
